import { Component, OnInit } from '@angular/core';
import { AutomationsService } from '../../common/_services/automations.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Automation } from '../../common/_types/automation';
import { firstValueFrom, Observable } from 'rxjs';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { AutomationsEventsService } from '../../common/_services/automations-events.service';
import { AutomationsActionsService } from '../../common/_services/automations-actions.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { AutomationsCompaniesService } from '../../common/_services/automations-companies.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TemplateCompanyComponent } from '../../templates/templates-detail/template-company/template-company.component';
import { CompanyContractsComponent } from '../../company-contracts/company-contracts.component';
import { AutomationCompany } from '../../common/_types/automation-company';
import { AutomationsActionsDetailComponent } from './automations-actions-detail/automations-actions-detail.component';
import { DatasetsFieldsService } from '../../reports/_services/datasets-fields.service';
import { CasesTypesRoutingModule } from '../../cases-types/cases-types-routing.module';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';

@Component({
    selector: 'app-automations-detail',
    templateUrl: './automations-detail.component.html',
    styleUrls: ['./automations-detail.component.css'],
    standalone: false
})
export class AutomationsDetailComponent implements OnInit {
  public automationFormGroup!: RxFormGroup;
  public automation: Automation = new Automation();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public events: any = [];
  public automationsActions: any = [];
  public totalAutomationsActions: number= 0;
  public automationsCompanies: any = [];
  public totalAutomationsCompanies: number= 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  private lastGridEventAutomationsCompanies: any;
 public automationEventConfig: any = {
   values: {}
 };

  constructor(
      private automationsService: AutomationsService,
      private router: Router,
      private confirmationService: ConfirmationService,
      private messageService: MessageService,
      public topbarService: TopbarService,
      private formBuilder: RxFormBuilder,
      private route: ActivatedRoute,
      private loginService: LoginService,
      private formValidationService: FormValidatorService,
      private automationsEventsService: AutomationsEventsService,
      private automationsActionService: AutomationsActionsService,
      private automationsCompaniesService: AutomationsCompaniesService,
      private dialogService: DialogService,
          private config: DynamicDialogConfig,
        private dynamicDialogRef: DynamicDialogRef) 
    { 
      this.automationFormGroup = this.formBuilder.formGroup<Automation>(this.automation) as RxFormGroup;
    }

  async ngOnInit() {
      //this.topbarService.setTitle("Detalles de automatización");
      //this.topbarService.addBreadcrumb("Automatizaciones", "/automations");
      let id = this.config.data.id;// this.route.snapshot.params['id'];
      if (id != null && id != '0') {
        await this.loadData(id);
        await this.loadAutomationActions({first: 0, rows: 10});
        await this.loadAutomationsCompanies({first: 0, rows: 10});
      } 
      
      this.allowWrite = this.loginService.hasPermission('AUTOMATIONS.WRITE');
      this.allowDelete = this.loginService.hasPermission('AUTOMATIONS.DELETE');
      this.loadEvents();  
    }
  
    async loadData(id: string) {
      this.automation = await firstValueFrom(this.automationsService.get(id, {include: ['automationEvent']}));
      this.automationFormGroup.patchValue(this.automation);

      //Mostramos la información del evento
      if(this.automation.automationEventId != null){
        this.automation.automationEvent.eventConfig.fields.map(async (element:any) => {
          // ⚡ Si tiene SQL, carga las opciones desde el servidor
          if (element?.optionsSql) {
            element.optionsItems = await this.loadDropdownOptions(this.automation.automationEvent.id as string, element.name);                        
          }
          let value = this.automation.eventConfig.values[element.name];
          if(value!=null){
            if(element.inputType == "bool"){
              this.automationEventConfig.values[element.name] = value == "1" ? true : false;
            }else if(element.inputType == "multiselect"){          
              this.automationEventConfig.values[element.name] = value.split(",");
            }else{
              this.automationEventConfig.values[element.name] = value;
            }
          }
        });       
      }
    }

    async loadAutomationEvent($event:any){
      let response = await firstValueFrom(this.automationsEventsService.get($event.value));
      this.automation.automationEvent = response;
      this.automation.automationEvent.eventConfig.fields.map(async (element:any) => {
        // ⚡ Si tiene SQL, carga las opciones desde el servidor
        if (element?.optionsSql) {
          element.optionsItems = await this.loadDropdownOptions(this.automation.automationEvent.id as string, element.name);                        
        }else{
          this.automationEventConfig.values[element.name] = element.value;
        }
      });
    }

    async loadDropdownOptions(id: string, name: string){    
      let response = await firstValueFrom(this.automationsEventsService.getDropdownOptions(id, name));         
      return response.result;
    }


  
    async loadAutomationActions($event: any){
      this.lastGridEvent = $event;
      let params: IParamsCollection = {
        page: { number: $event.first + 1, size: $event.rows },
        include: ['action']
      }
      if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
      let filters:any = {
        automationId: new Filter(FilterOperation.equals, 'automationId', '', this.automation.id)
      };
      params.filter = FilterBuilder.fromObject(filters).build();
    
      let response = await firstValueFrom(this.automationsActionService.all(params));
      this.automationsActions = response.data;
    }

    async loadAutomationsCompanies($event:any){
      this.lastGridEventAutomationsCompanies = $event;
      let params: IParamsCollection = {
        page: { number: $event.first + 1, size: $event.rows },
        include: ['company', 'contract']
      }
      if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

      let filters:any = {
        automationId: new Filter(FilterOperation.equals, 'automationId', '', this.automation.id)
      };
      params.filter = FilterBuilder.fromObject(filters).build();
    
      let response = await firstValueFrom(this.automationsCompaniesService.all(params));
      this.automationsCompanies = response.data;
    }

    async loadEvents(){
      let params:IParamsCollection = {}    
      let response = await firstValueFrom(this.automationsEventsService.all(params));
      this.events = response.data;
    }
    
    convertArrayValuesToString(obj: any): any {
      if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
          if (key === 'value' && Array.isArray(obj[key])) {            
            obj[key] = obj[key].join(',');
          } else if(Array.isArray(obj[key])) {            
            obj[key] = obj[key].join(',');
          } else if(typeof obj[key] === 'number'){
            obj[key] = obj[key] + "";
          }  else if(typeof obj[key] === 'boolean'){
            obj[key] = obj[key] ? "1" : "0";
          } else if (typeof obj[key] === 'object') {
            this.convertArrayValuesToString(obj[key]);
          }
        }
      }
      return obj;
    }

    async save() {
      let valid = this.formValidationService.validateForm(this.automationFormGroup);
      if (valid) {
        this.automation = Object.assign(this.automation, this.automationFormGroup.value);  
        if(this.automation.eventConfig==null) this.automation.eventConfig = {};
        this.automation.eventConfig.values = this.convertArrayValuesToString(this.automationEventConfig.values);
        await firstValueFrom(this.automationsService.save(this.automation));  
        this.messageService.add({ closable: true, severity: 'success', summary: "Automatización guardada correctamente." });  
        this.cancel();
      } else {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
      }
    }
  
    async delete() {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la automatización?",
        header: "Eliminar",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.automationsService.delete(this.automation.id).subscribe({
            next: (data: any) => {
              this.cancel();
              this.messageService.add({ closable: true, severity: 'success', detail: "Automatización eliminada correctamente." });
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  
    cancel() {
      //this.router.navigate(['automations']);
      
    this.dynamicDialogRef.close();
    }
  
    addCompany(automationCompany: any, filtered:boolean) {
      var selectedContracts = [];
      selectedContracts = this.automationsCompanies.length > 0 ?  this.automationsCompanies.map((m:any) => m.contractId) : [];
      if(filtered) selectedContracts = this.automationsCompanies.filter((m:any) => m.companyId == automationCompany.companyId).map((m:any) => m.contractId);
      const ref = this.dialogService.open(CompanyContractsComponent, {
        closable: true,
        modal: true,
        data: {
          companyId: (automationCompany ? automationCompany.companyId : null),
          selectedContracts: selectedContracts
        },
        header: "Asignar compañía aseguradora",
        width: '40%'
      });

      ref.onClose.subscribe(async (data: any) => {
        //guardar en la base de datos el companyId y los contratos seleccionados
        if(data != null){
          var contractsToDelete: any[] = [] ;
          //Miramos los que ya están.
          var actualAutomationCompanies = await firstValueFrom(this.automationsCompaniesService.all({filter : FilterBuilder.fromObject({companyId: data.companyId}).build()}));

          //para que funcione, pero TODO hacerlo bien
          const removePromises = actualAutomationCompanies.data.map((element:any) => {
            return   this.automationsCompaniesService.delete(element.id);     
          });

          if(data.selectedContracts.length == 0) data.selectedContracts = ["-1"];

          const addPromises = data.selectedContracts.map( (contract:any) => {      
              let result = new AutomationCompany();
              result.contractId =  contract != "-1" ? contract : null;
              result.automationId = this.automation.id as string;
              result.companyId = data.companyId;
              return this.automationsCompaniesService.save(result);
          });

          Promise.all([...removePromises, ...addPromises]).then((results: any) => {
            this.loadAutomationsCompanies(this.lastGridEventAutomationsCompanies);
          });
        }
      });

    }

    deleteCompany(automationCompany: any, all:boolean) {
      console.log("deleteCompany", all, automationCompany);
      var message = "";
      if(all){
        message = "¿Está seguro que desea desasignar todos los contratos de la compañía aseguradora '" + automationCompany.company?.name + "' a esta automatización?";
      }else{
        message = "¿Está seguro que desea desasignar el contrato '" +  (automationCompany.contract?.name)+ "' de la compañía aseguradora '" + automationCompany.company?.name + "'?";
      }
      this.confirmationService.confirm({
        message: message,
        header: "Desasignar contrato/s de companía aseguradora a la automatización",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          if(!all){
            this.automationsCompaniesService.delete(automationCompany.id).subscribe({
              next: (data: any) => {
                this.loadAutomationsCompanies(this.lastGridEventAutomationsCompanies);
                this.messageService.add({ closable: true, severity: 'success', detail: "Contrato desasignada correctamente." });
              },
              error: (error: any) => {
                this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
              }
            });
          }else{
            var allContractsFromCompany = this.automationsCompanies.filter((m:any) => m.companyId == automationCompany.companyId);
           
            allContractsFromCompany.forEach((element:any) => {
              this.automationsCompaniesService.delete(element.id).subscribe({
                next: (data: any) => {
                },
                error: (error: any) => {
                  this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
                }
              });
            }); /*.finally((m: any) => {
              
            } );*/
              setTimeout(() => {
                this.loadAutomationsCompanies(this.lastGridEventAutomationsCompanies);
                this.messageService.add({ closable: true, severity: 'success', detail: "Contratos desasignados correctamente." });
              }, 1000)
          }
        },
        reject: (error: any) => {
          //nada
        }
      });
  
    }

    editAutomationEvent(event: any){
      const ref = this.dialogService.open(AutomationsActionsDetailComponent, {
        closable: true,
        modal: true,
        data: {
          id: (event ? event.id : null),
          automationId: this.automation.id
        },
        header: event ? "Editar acción": "Añadir acción",
        width: '40%'
      });

      ref.onClose.subscribe(async (data: any) => {
        this.loadAutomationActions(this.lastGridEvent);
      });
    }

    deleteAutomationEvent(event: any){

    }

}
